<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">엑셀 양식 다운로드</td>
                <td>
                    <div>
                        <el-button class="com_btn" type="info"
                                   @click="download('https://imagedev.e-ot.io/excel/lookbook_excel.xlsx')">엑셀 양식 다운로드
                        </el-button>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">파일 업로드</td>
                <td>
                    <div>
                        <el-upload
                                class="edu-video-uploader mr15"
                                :auto-upload="false"
                                action=""
                                accept=".xlsx, .xls, .csv"
                                :show-file-list="false"
                                list-type="picture"
                                :file-list="files"
                                :on-change="uploadCreateFile"
                                v-if="!hasFile('files')"
                        >
                            <el-button class="com_btn" type="info">파일 업로드</el-button>
                        </el-upload>
                        <div v-else>
                            <div class="in_block mr15">{{ files.name }}</div>
                            <button class="el-icon-circle-close" style="font-size: 15px; cursor: pointer;"
                                    @click="removeFile()"></button>
                        </div>
                    </div>
                </td>

            </tr>
        </table>

    </div>
</template>

<script>
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/mixins/event-bus";

export default {
    name: "ExcelLookbookComponent",
    mixins: [alertMixins],
    inject: ['changeLoading'],
    components: {},
    provide() {
        return {}
    },
    props: {
        uccKey: {default: 0},
    },
    data() {
        return {
            files: [],
        }
    },
    created() {
    },
    mounted() {
        EventBus.$on('writeExcel', this.writeExcel);
    },
    beforeDestroy() {
        EventBus.$off('writeExcel');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        download(url) {
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.style.display = 'none';
            anchor.target = '_blank'
            document.body.appendChild(anchor);
            anchor.click();
        },
        uploadCreateFile(files) {
            this.files = files;
        },
        hasFile(typeName) {
            return !util.isEmpty(this[typeName]) && !util.isEmpty(this[typeName].url);
        },
        removeFile() {
            this.files = []
        },
        writeExcel() {
            EventBus.$emit('changeLoading', true)
            if (util.isEmpty(this.files)) {
                EventBus.$emit('changeLoading', false)
                this.errorAlert('파일을 업로드 해주세요.');
                return false
            }
            if (this.files.hasOwnProperty('raw')) {
                let file = this.files
                let formData = new FormData();
                formData.append('file', file.raw);
                try {
                    this.$api.$lookbook.createExcel(formData).then(res => res.Data.Result).then(res => {
                        EventBus.$emit('changeLoading', false)
                        let result = res.List
                        if (res.Info.status) {
                            this.createAlert({
                                content: `등록에 성공하였습니다.`,
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                        } else {
                            this.errorAlert('등록에 실패했습니다.');
                        }

                    })
                } catch (e) {
                    console.log(e);
                }
            }
        },
        returnResultType(type) {
            switch (type) {
                case 1 :
                    return true
                default :
                    return "업로드에 실패하였습니다."

            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
